<template>
    <div class="page-content">
        <!-- Action buttons -->
        <div class="actions-container">
            <button class="btn btn-primary margin-left-10" @click="onBrowseFileClick">
                Upload PDF file
                <i class="icon-attachments"></i>
            </button>
            <button class="btn btn-success margin-left-10" @click="runAnalysis" :disabled="file == null">
                Run analysis
                <i class="icon-lifecycle"></i>
            </button>
        </div>
        <web-viewer v-if="file != null" :file="file" ref="webViewerComponent"></web-viewer>
        <div class="upload-file-message text-center" v-if="file == null">
            <i class="icon-contracts font-size-100"></i>
            <h2>No file uploaded.</h2>
            <h2><b>Upload contract and run analysis!</b></h2>
            <button class="btn btn-primary btn-lg margin-left-10" @click="onBrowseFileClick">
                Upload PDF file
                <i class="icon-attachments"></i>
            </button>
        </div>
        <div class="import-container">
            <input type="file" accept="application/pdf" @change="chooseFile($event)" id="file-import" ref="browseFile">
        </div>
    </div>
</template>

<script>
    export default {
        name: "view-contract",
        components: {},
        data: () => {
            return {
                file: null
            }
        },
        mounted: function () {},
        methods: {
            /**
             * On upload file clicked
             */
            onBrowseFileClick() {
                this.$refs.browseFile.click();
            },
            /**
             * Choose PDF file
             */
            chooseFile(event) {
                var file = event.target.files[0];
                if (typeof FileReader != "undefined") {
                    var reader = new FileReader();
                    var me = this;
                    reader.onloadend = function (e) { };
                    if (file &&
                        file.type.match("application/pdf")) {
                        reader.readAsDataURL(file);
                        me.file = file;
                    } else {
                        alert("The file must be with .pdf extension");
                    }
                } else {
                    alert("This browser does not support FileReader.");
                }
            },
            /**
             * Trigger runAnalysis function in WebViewer component
             */
            runAnalysis() {
                this.$refs.webViewerComponent.runAnalysis();
            }
        }
    }
</script>
<style scoped>
    @import '~/styles/plugins/notifIt.css';
    @import '~/styles/bootstrap.css';
    @import '~/styles/trackado-icons.css';
    @import '~/styles/site.css';
    @import '~/styles/override.css';

    .page-content {
        width: 100%;
        height: 100vh;
        margin: 0;
        padding: 0;
        list-style: none;
        color: #2c3e50;
    }

    .actions-container {
        height: 40px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: left;
        border-bottom: 1px solid #e0e0e0;
    }

    .upload-file-message {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .import-container,
    #file-import {
        display: none;
    }

    .font-size-100 {
        font-size: 100px;
    }

</style>


// WEBPACK FOOTER //
// ViewContract.vue?58188efc